<div class="container">
  <h1>
    @if (meetingInfo?.MeetingName) {
      <span>
        {{ meetingInfo?.ProjectName }}
      </span>
    } @else {
      Project Name
    }
  </h1>
  <h3>
    @if (meetingInfo?.MeetingName) {
      <span> Register for {{ meetingInfo?.MeetingName }} </span>
    }
  </h3>

  <p role="alert" class="step">Thank you! You have successfully registered!</p>

  @if (!noUrl) {
    @if (showProgressBar) {
      <div class="progress-bar-timer" aria-live="polite">
        <p>You will be automatically redirected in 5 seconds...</p>
        <mat-progress-bar id="progressBar" mode="determinate" [value]="progressValue"></mat-progress-bar>
        <button class="blue-button cancel-button" (click)="cancelRedirect()">Stay on this page</button>
      </div>
    }
    @if (!showProgressBar) {
      <div class="manual-redirect" aria-live="polite">
        <p>Click below to continue when you're ready.</p>
        <button class="blue-button proceed-button" (click)="redirectToMeeting()">Proceed</button>
      </div>
    }
  } @else {
    <div class="progress-bar-timer">
      <p>There is currently no URL available right now. Please try again later.</p>
    </div>
  }
</div>
